module.exports = __webpack_public_path__ + "static/img/回复授权信息.87d9f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Doc/assets/imgs/回复授权信息.png
// module id = v8Ll
// module chunks = 0